import cloneDeep from 'clone-deep'
import {
  createApiConditionList,
  createApiGroupList,
} from '../ApiOptimize'

export const createCallAPIActionList = (jsonForm = {}) => {
  let apiGroup = jsonForm?.apiGroup || []
  let apiCondition = jsonForm?.apiCondition || []
  let filter = apiGroup.filter(({ condition = {} }) => condition?.condition)
  filter = createApiGroupList(filter)
  let conditionList = createApiConditionList(apiCondition).map((api) =>
    cloneDeep(api),
  )
  let apiKeyList = []
  return [...filter, ...conditionList].filter((api) => {
    if (!api?.key) return true
    if (apiKeyList.includes(api.key)) return false

    apiKeyList.push(api.key)
    return true
  })
}

export const getCallAPIAction = (jsonForm, key) => {
  let apiGroup = createCallAPIActionList(jsonForm)
  return apiGroup.find((api) => api.key === key)
}
